import { SVGProps } from "react";

export const UpDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7 8.91687L4.16667 11.7502L1.33334 8.91687M1.33203 4.08285L4.16536 1.24951L6.9987 4.08285"
      stroke="#292A2F"
      strokeOpacity="0.7"
    />
  </svg>
);
